import Vue from "vue";
import VueTabs from "vue-nav-tabs/dist/vue-tabs.js";
// I will use custom style, so I don't need this
// import "vue-nav-tabs/themes/paper.css";

Vue.use(VueTabs);
